import React, { useState, useEffect } from 'react';
import './OpenEndMeetingModal.css'; // Add your CSS file for styling
import axios from 'axios';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import { encryptWithManagedIV } from '../../utils/DecryptingModule';

export default function OpenEndMeetingModal() {
  const { room } = useVideoContext();
  const history = useHistory();
  // const { search, state } = useLocation();
  // const [input, setInput] = useState<string>('');
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  // const { URLRoomName } = useParams<{ URLRoomName?: string }>();
  // const [roomName, setRoomName] = useState<string>('');
  // const [UserName, setUserName] = useState<string>('');
  // const [Link, Setlink] = useState<string>('');

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const Approve = () => {
    history.replace('/end');
    room!.disconnect();
  };
  const Cancel = () => {
    // history.replace('/end');
    // room!.disconnect();
    document.getElementById('closebutton')?.click();
  };
  // Capture global keyboard events

  return (
    <div className="button-container chatbox">
      <div className="row">Are you sure you want to exit the meeting?</div>
      <div className="row">
        {' '}
        <button className="callbtn" onClick={Approve}>
          Yes
        </button>{' '}
      </div>
      <div className="row">
        {' '}
        <button className="callbtn" onClick={Cancel}>
          Cancel
        </button>{' '}
      </div>

      {/* 
      <div className="button-container">
        <div className="button-container">
          <div className="row">
          </div>
          <div className="row">          
          </div>
          <div className="row">         
          </div>
          <div className="row">
          </div>
          <div className="row"></div>
          <div className="row buttonssms">
             <button onClick={Participants} className="callbtn">
              participants
            </button> 
          </div>
        </div>
      </div> */}
    </div>
  );
}
